'use client';

import { ChevronLeft } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { NAV_BACK, NavLink } from './page-transition';

interface BackButtonProps {
  href: string;
  label?: string;
}

/**
 * iOS-style back affordance. Navigates to the hierarchical parent rather than
 * history.back() so deep links behave predictably.
 */
export function BackButton({ href, label }: BackButtonProps) {
  const t = useTranslations();

  return (
    <NavLink
      href={href}
      direction={NAV_BACK}
      className="-ml-2 inline-flex h-11 min-w-11 items-center justify-center gap-0.5 rounded-md pr-2 text-secondary-foreground transition-transform duration-fast ease-out active:scale-95"
      aria-label={label ?? t('common.back')}
    >
      <ChevronLeft className="size-5" />
      {label ? (
        <span className="max-w-28 truncate text-label">{label}</span>
      ) : null}
    </NavLink>
  );
}
